import React from "react";
import { MenuItem, TextField } from "@mui/material";
import { DropDownComboOption } from "./GenericFilter";
import { useStyles } from "./SideNavBar";
import { globalTheme } from "../../common/theme";

export type DropDownTextBoxProps = {
    dropDownBoxId?: string;
    dropDownBoxLabel?: string;
    dropDownBoxDisabled: boolean;
    className: string;
    dropDownBoxWidth: string;
    dropDownBoxOptions: DropDownComboOption[];
    dropDownBoxValue: string;
    firstTextBoxLabel?: string;
    firstTextBoxName?: string;
    firstTextBoxValue?: string;
    firstTextBoxWidth?: string;
    firstTextBoxMinWidth?: string;
    firstTextBoxReadOnly?: boolean;
    onSelectionChanged: Function;
    onTextBoxValueChanged?: Function;
    type?: string;
}

export function CustomDropDown1(props: DropDownTextBoxProps ) {
    const componentStyle = {
        display: 'flex'
    };
    
    const style = { ...useStyles(), ...globalTheme() };

    const [selectedValue, setSelectedValue] = React.useState<string | null>(props.dropDownBoxValue);

    const selectedValueChanged = (newValue: string | null) => {
        setSelectedValue(newValue);
        props.onSelectionChanged(newValue);
    };

    const valueChanged = (newValue: string | null) => {
        if (props.onTextBoxValueChanged)
            props.onTextBoxValueChanged(newValue);
    };

    return (
        <div className={props.className} style={componentStyle}>
            <TextField
                id={props.dropDownBoxId}
                style={{width: props.dropDownBoxWidth, minWidth: props.dropDownBoxWidth}}
                value={selectedValue}
                onChange={(e) => selectedValueChanged(e.target.value)}
                select
                label={props.dropDownBoxLabel}
                disabled={props.dropDownBoxDisabled}
                size="small"
                fullWidth
            >
                {props.dropDownBoxOptions.map((item)=> (
                    <MenuItem key={item.name + "-" + item.value} value={item.name}>
                        {item.name}
                    </MenuItem>
                ))}
            </TextField>
            <TextField
                label={props.firstTextBoxLabel}
                InputLabelProps={{ shrink: true }}
                className={`${props.type === "number" ? style.NumberTextField : ""}`}
                name={props.firstTextBoxName}
                value={props.firstTextBoxValue}
                variant="outlined"
                type={props.type}
                inputProps={{ readOnly: props.firstTextBoxReadOnly }}
                onChange={(e) => valueChanged(e.target.value)}                
                style={{width: props.firstTextBoxWidth, minWidth: props.firstTextBoxMinWidth}}
                size="small"                      
            />
        </div>
    );
}

